import qs from 'qs';

export function transformRequestOptions(params) {
  return qs.stringify(params, { encode: false, indices: false });
}
